import { headers, apiV2 } from '../api'

import { RewardsPointsData } from 'src/types/RewardsPoints'
import { rewardPointsMapper } from './rewardPointsMapper'

import { CategoryRewardsPointsData } from 'src/types/CategoryRewardsPoints'
import { categoriesRewardsPointsMapper } from './categoriesRewardsPointsMapper'

export async function getRewardsPoints(slug: string) {
  const { data } = await apiV2.get<RewardsPointsData>(
    `/canais/pontos-recompensa/${slug}`,
    {
      headers,
    }
  )
  return rewardPointsMapper(data)
}

export async function getCategories(amount = 12) {
  const { data } = await apiV2.get<CategoryRewardsPointsData[]>(
    `/canais/pontos-recompensa/categorias/top-vendas?limit=${amount}`,
    { headers }
  )
  return categoriesRewardsPointsMapper(data)
}
